<template>
	<v-dialog v-model="isDialogShow" persistent max-width="1500" content-class="rounded-xl">
    <v-form ref="formProfile" role="form">
      <v-card class="pa-4">
        <v-card-title class="font-size-16 font-weight-bold secondary--text">Data Member</v-card-title>
				<v-card-subtitle>Mohon lengkapi data anda terlebih dahulu</v-card-subtitle>
				
        <v-row>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-text-field 
							label="Nama Lengkap" 
							color="primary" 
							prepend-inner-icon="mdi-account" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_name" 
							@blur="member_bank_account_name = member_name"
							:rules="rules.input"
							:error-messages="(errorValidation !== undefined && errorValidation['name'] !== undefined ) ? [errorValidation['name']] : []"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-text-field 
							label="Email" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-email" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_email" 
							:rules="rules.email"
							:error-messages="(errorValidation !== undefined && errorValidation['email'] !== undefined ) ? [errorValidation['email']] : []"
							@change="changeInputData"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-autocomplete 
							label="Pilih Jenis Identitas" 
							class="input-regis" 
							hide-details="auto" 
							outlined
							dense
							no-data-text="Tidak ada data" 
							color="primary" 
							prepend-inner-icon="mdi-card-account-details" 
							item-color="primary" 
							:items="['KTP', 'SIM', 'PASPOR']" 
							ref="identity_type" 
							v-model="member_identity_type" 
							:rules="rules.input" 
							:error-messages="(errorValidation !== undefined && errorValidation['identity_type'] !== undefined ) ? [errorValidation['identity_type']] : []"
							@change="member_identity_no = ''"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-text-field 
							v-if="member_identity_type == 'PASPOR' || member_identity_type == ''" 
							label="Nomor Identitas" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-card-account-details" 
							hide-details="auto" 
							outlined
							dense
							:rules="rules.input" 
							:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
							v-model="member_identity_no" ></v-text-field>
            <v-text-field 
							v-else 
							label="Nomor Identitas" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-card-account-details" 
							hide-details="auto" 
							outlined
							dense
							:rules="rules.input" 
							:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
							v-model="member_identity_no" 
							@keypress="onlyNumber"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-text-field 
							label="Nomor Handphone" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-cellphone" 
							hide-details="auto"
							outlined
							dense 
							v-model="member_mobilephone" 
							:rules="rules.phone"
							:error-messages="(errorValidation !== undefined && errorValidation['mobilephone'] !== undefined ) ? [errorValidation['mobilephone']] : []"
							@change="changeInputData" 
							@keypress="onlyNumber"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0 mt-4 mb-2 d-flex flex-column flex-md-row align-md-center justify-md-space-between">
            <v-card-subtitle class="py-0 px-0 grey--text lighten-5"><v-icon dense class="mr-2">mdi-account-cog-outline</v-icon>Jenis Kelamin</v-card-subtitle>
            <v-radio-group v-model="member_gender" row hide-details="auto" class="ml-md-5 pl-md-5 mt-4 mt-md-0 pt-0"  :rules="rules.input"
						:error-messages="(errorValidation !== undefined && errorValidation['gender'] !== undefined ) ? [errorValidation['gender']] : []">
              <v-radio label="Laki-laki" value="Laki-laki"></v-radio>
              <v-radio label="Perempuan" value="Perempuan"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-text-field 
							label="Tempat Lahir" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-home-city" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_birth_place" 
							:rules="rules.input" 
							:error-messages="(errorValidation !== undefined && errorValidation['birth_place'] !== undefined ) ? [errorValidation['birth_place']] : []"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-menu v-model="bornDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field 
									label="Tanggal Lahir" 
									color="primary" 
									class="input-regis" 
									prepend-inner-icon="mdi-calendar" 
									readonly 
									v-bind="attrs" 
									v-on="on" 
									hide-details="auto"
									outlined
									dense 
									:value="convertDate(member_birth_date)" 
									:rules="rules.input" 
									:error-messages="(errorValidation !== undefined && errorValidation['birth_date'] !== undefined ) ? [errorValidation['birth_date']] : []"></v-text-field>
              </template>
              <v-date-picker 
								locale="id" 
								first-day-of-week="0" 
								color="primary" 
								:max="today" 
								@input="bornDate = false" 
								ide-details="auto" 
								outlined
								dense
								v-model="member_birth_date"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="4" class="px-5 pb-0">
            <v-autocomplete 
							label="Provinsi" 
							no-data-text="Tidak ada data yang dapat ditampilkan" 
							color="primary" 
							item-color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-map-marker" 
							:items="provinces" 
							item-text="province_name" 
							item-value="province_id" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_province_id" 
							@change="changeProvince" 
							:rules="rules.input" 
							:error-messages="(errorValidation !== undefined && errorValidation['province_id'] !== undefined ) ? [errorValidation['province_id']] : []"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" class="px-5 pb-0">
            <v-autocomplete 
							label="Kabupaten / Kota" 
							no-data-text="Pilih provinsi terlebih dulu" 
							color="primary" 
							item-color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-map-marker" 
							:items="cities" 
							item-text="city_name" 
							item-value="city_id" 
							hide-details="auto"
							outlined
							dense 
							v-model="member_city_id" 
							:rules="rules.input"
							:error-messages="(errorValidation !== undefined && errorValidation['city_id'] !== undefined ) ? [errorValidation['city_id']] : []" 
							@change="changeCity"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" class="px-5">
            <v-autocomplete 
							label="Kecamatan" 
							no-data-text="Pilih kota terlebih dulu" 
							color="primary" 
							item-color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-map-marker" 
							:items="subdistricts" 
							item-text="subdistrict_name" 
							item-value="subdistrict_id" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_subdistrict_id" 
							:rules="rules.input"
							:error-messages="(errorValidation !== undefined && errorValidation['subdistrict_id'] !== undefined ) ? [errorValidation['subdistrict_id']] : []"  ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" class="px-5 pb-0">
            <v-textarea 
							label="Alamat Lengkap" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-map-marker-plus" 
							rows="2" 
							counter="255" 
							maxlenght="255" 
							no-resize 
							hide-details="auto" 
							outlined
							dense
							v-model="member_address" 
							:rules="rules.input" 
							:error-messages="(errorValidation !== undefined && errorValidation['address'] !== undefined ) ? [errorValidation['address']] : []" ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="false">
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-autocomplete 
							label="Nama Bank" 
							no-data-text="Tidak ada data yang dapat ditampilkan" 
							color="primary" 
							item-color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-bank-outline" 
							:items="banks" 
							item-text="bank_name" 
							item-value="bank_id"
							return-object 
							hide-details="auto" 
							outlined
							dense
							v-model="member_bank_id" 
							:rules="rules.input"
							@change="selectBank()"
							:error-messages="(errorValidation !== undefined && errorValidation['bank_name'] !== undefined ) ? [errorValidation['bank_name']] : []" ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" class="px-5 pb-0">
            <v-text-field 
							label="Nama Rekening" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-clipboard-account-outline" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_bank_account_name" 
							:rules="rules.input"
							:error-messages="(errorValidation !== undefined && errorValidation['bank_account_name'] !== undefined ) ? [errorValidation['bank_account_name']] : []"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="px-5">
            <v-text-field 
							label="Nomor Rekening" 
							color="primary" 
							class="input-regis" 
							prepend-inner-icon="mdi-credit-card-outline" 
							hide-details="auto" 
							outlined
							dense
							v-model="member_bank_account_no" 
							:rules="rules.bank_no"  
							@change="changeInputData" 
							@keypress="onlyNumber"
							:error-messages="(errorValidation !== undefined && errorValidation['bank_account_no'] !== undefined ) ? [errorValidation['bank_account_no']] : []"></v-text-field>
          </v-col>
        </v-row>
				<v-row class="px-2" justify="center" >
					<v-col  cols="12" sm="6">
						<v-card class="amber lighten-4 rounded-lg d-flex justify-center" elevation="0">
							<v-card-subtitle class="font-size-14 secondary--text">Mohon segera update data bank ke admin perusahaan</v-card-subtitle>
						</v-card>
					</v-col>
				</v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="grey darken-1" height="45" outlined
					dense class="text-capitalize rounded-xl" :loading="btnLoading" @click.stop="modalHide">{{ closeText }}</v-btn> -->
          <v-btn color="primary" height="45" depressed class="text-capitalize rounded-xl white--text mt-5 px-10" :loading="btnLoading" @click.stop="confirm">{{ confirmText }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>
	</v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment'
function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}
export default {
	data () {
		return {
      today: moment(new Date()).format('YYYY-MM-DD'),
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Batal',
			confirmText: 'Simpan',
      isEditing: true,
      joinDate: false,
			bornDate: false,
      member_name: '',
			member_email: '',
			member_mobilephone: '',
			member_gender: '',
			member_birth_place: '',
			member_birth_date: '',
			member_province_id: '',
			member_city_id: '',
			member_subdistrict_id: '',
			// member_bank_id: '',
			// member_bank_name: '',
			// member_bank_account_name: '',
			// member_bank_account_no: '',
			member_address: '',
			member_identity_no: '',
			member_identity_type: '',
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong',
				],
				email: [
				v => !!v || 'Tidak boleh kosong',
				v => !!validateEmail(v) || 'Format Email tidak sesuai',
				],
				phone: [
				v => !!v || 'Tidak boleh kosong',
				// v => ( v && !this.errorValidation.member_mobilephone ) || "Nomor Handphone sudah digunakan oleh pengguna lain",
				],
				bank_no: [
				v => !!v || 'Tidak boleh kosong',
				// v => ( v && !this.errorValidation.member_bank_account_no ) || "Nomor Rekening sudah digunakan oleh pengguna lain",
				],
			},
		}
	},
	computed: {
    ...mapState('autentikasi', ['userData']),
    ...mapState('opsi', ['provinces', 'cities', 'subdistricts', 'banks']),
		...mapState('profil', ['myProfile']),
		...mapState(['errorValidation']),
	},
	methods: {
    ...mapActions('opsi', ['getProvince', 'getCity', 'getSubdistrict', 'getBank']),
    ...mapActions('profil', ['updateProfileFirst', 'getProfileMitra']),
    ...mapMutations('autentikasi', ['setProfileData']),
		...mapMutations(['emptyErrorValidation']),

    onlyNumber($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
				$event.preventDefault();
			}
		},

    convertDate(val) {
      if (val) {
        return moment(val).format('DD MMM yyyy')
      } else {
        return ''
      }
		},
		modalHide() {
			this.isDialogShow = false
			this.btnLoading = false
		},
		modalShow() {
			this.isDialogShow = true
      this.getData()
		},
		loadingButton() {
			this.btnLoading = true
		},
		normalButton() {
			this.btnLoading = false
		},
		confirm() {
			// this.$emit('action')
      this.save()
		},
    changeProvince() {
			this.getCity({province_id: this.member_province_id})
			this.member_city_id = ''
			this.member_subdistrict_id = ''
		},
		changeCity() {
			this.getSubdistrict({city_id: this.member_city_id})
			this.member_subdistrict_id = ''
		},
		async selectBank() {
			const selectedBank = await this.member_bank_id
			this.member_bank_id = selectedBank.bank_id
			this.member_bank_name = selectedBank.bank_name
		},
    changeInputData() {
			this.emptyErrorValidation()
			this.$refs.formProfile.resetValidation()
		},
    cancelSave() {
			this.isEditing = false
			this.getCity({province_id: this.data.member_province_id}).then(()=> {
				this.getSubdistrict({city_id: this.data.member_city_id}).then(()=> {
					this.setDataProfile()
				})
			})
		},
    async getData() {
      await this.getProvince()
			await this.getBank()
    },
    async save() {
			if (this.$refs.formProfile.validate()) {
				this.btnLoading = true
				
				let formData = new FormData()
				formData.append('name', this.member_name)
				formData.append('email', this.member_email)
				formData.append('mobilephone', this.member_mobilephone)
				formData.append('gender', this.member_gender)
				formData.append('birth_place', this.member_birth_place)
				formData.append('birth_date', this.member_birth_date)
				formData.append('address', this.member_address)
				formData.append('province_id', this.member_province_id)
				formData.append('city_id', this.member_city_id)
				formData.append('subdistrict_id', this.member_subdistrict_id)
				// formData.append('bank_id', this.member_bank_id)
				// formData.append('bank_name', this.member_bank_name)
				// formData.append('bank_account_name', this.member_bank_account_name)
				// formData.append('bank_account_no', this.member_bank_account_no)
				formData.append('identity_type', this.member_identity_type)
				formData.append('identity_no', this.member_identity_no)
        
				await this.updateProfileFirst(formData).then(() => {
          this.updateData()
					this.$refs.formProfile.resetValidation()
				})
			} else {
				this.btnLoading = false
			}
		},
    async updateData() {
      await this.getProfileMitra()
      await this.setProfileData(this.myProfile)
      this.btnLoading = false
			this.modalHide()
    }
	}
};
</script>